import styled from 'styled-components';

const MenuWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export default MenuWrapper;
